var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 281,
    viewBox: "0 0 284 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.357 92.6796C166.021 98.5854 174.082 110.27 175.719 122.924L115.816 94.9908C126.562 88.1113 140.692 86.7739 153.357 92.6796Z",
    fill: "#FFF3BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.912 89.3438C150.602 87.3339 148.694 82.3056 150.648 78.1155C152.601 73.9261 157.679 72.159 161.989 74.1688C166.298 76.1785 168.208 81.2038 166.255 85.3932C164.301 89.5835 159.222 91.3536 154.912 89.3438Z",
    fill: "#FFF3BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0103 71.3719C97.7827 80.8811 97.9264 98.0607 97.5904 103.926L113.55 100.213L173.487 128.162C175.706 134 181.363 145.506 192.201 148.342C203.04 151.182 229.776 133.2 244.638 136.957C263.676 141.77 259.37 145.303 253.581 146.302C250.41 146.85 236.017 156.965 210.374 166.422C175.578 179.256 153.101 191.441 117.202 174.701C97.181 165.365 86.4206 144.564 82.6832 130.748C72.5089 129.531 58.363 122.212 50.7211 104.537C40.1163 80.0128 62.6759 60.9753 81.0103 71.3719ZM63.3249 99.5031C67.4535 109.053 73.5942 113.515 78.0177 115.578C79.492 116.265 80.8051 116.706 81.9271 116.989C82.916 113.654 83.6881 108.392 83.7942 104.629C83.8009 104.408 83.8127 104.185 83.8295 103.968C84.6091 94.0568 81.4179 87.0026 74.3494 82.9931C74.1298 82.87 73.9105 82.756 73.6898 82.6531C69.3831 80.6449 65.9616 83.3958 65.0133 84.2868C61.3316 87.7487 60.7011 93.436 63.3249 99.5031Z",
    fill: "#FFF3BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.521 170.83C105.619 174.022 110.147 176.879 115.108 179.192C120.61 181.758 126.028 183.82 131.342 185.458C136.102 194.222 139.489 204.335 135.541 212.802L106.163 199.103L76.7813 185.402C80.8766 176.62 91.4051 172.743 101.521 170.83Z",
    fill: "#FFF3BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 209,
    fill: "white",
    transform: "matrix(-0.906308 -0.422618 -0.422618 0.906308 283.184 90.8628)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.bc7d77bff99f98787f2c2bc6e1e68379.svg";
export { ForwardRef as ReactComponent };